import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import { localize } from 'helpers/translator'
import BaseButton from 'components/button/base/base_button'

import styles from './InputSelection.scss'

class InputSelection extends PureComponent {

	render() {
		return (
			<div>
				<button styleName='InputHolder-empty-text' onClick={this.props.newTextHandler}>{localize('matching_pairs_ct_input_add_text')}</button>
				<div styleName='InputHolder-empty'>
					<span styleName='InputHolder-empty-or'>{localize('matching_pairs_ct_input_add_or')}</span>
					<div styleName='InputHolder-empty-btn'>
						<BaseButton
							pill
							bgColor='border-blue'
							fontColor='blue'
							size='medium'
							onClick={this.props.addAnImageHandler}
						>
							{localize('matching_pairs_ct_input_add_image')}
						</BaseButton>
					</div>
				</div>
			</div>
		)
	}

}

export default CSSModules(InputSelection, styles, {allowMultiple: true})
